import { tasksGetters } from "./task/getters";


export const getters = {
    ...tasksGetters
};
